import { experienceBuilderApi } from 'api'

export const fetchSkills = (data: any) =>
  experienceBuilderApi.get<{ data: any[] }>('/marketing-capabilities/skills', {
    params: {
      ...data,
    },
  })
